import {Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {isPlatformBrowser, NgClass, NgForOf, NgStyle} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    NgStyle,
    NgForOf
  ],
  styleUrls: ['./location.component.less']
})
export class LocationComponent implements OnInit {
  supportsWebp = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.supportsWebp = document.createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') === 0;
    }
  }

  images = [
    {originUrl: 'assets/gallery/dart-rock-cafe-tobi-mimi.jpg'},
    {originUrl: 'assets/gallery/DRC-Lampe.jpg'},
    {originUrl: 'assets/images/dart-spielen-kassel-lohfelden.jpeg'},
    {originUrl: 'assets/images/dart-turnier-kasel-im-dart-rock-cafe.jpeg'},
    {originUrl: 'assets/images/schocken-wuerfeln.jpeg'},
    {originUrl: 'assets/gallery/dart-turnier-kassel.jpg'},
    {originUrl: 'assets/gallery/dart-turnier-sieger.jpg'},
    {originUrl: 'assets/gallery/lohfelden-kassel-dart.jpg'},
    {originUrl: 'assets/gallery/kassel-dart-spielen.jpg'},
    {originUrl: 'assets/gallery/dart-rock-cafe-kneipe.jpg'},
    {originUrl: 'assets/gallery/1.jpg'},
    {originUrl: 'assets/gallery/4.jpg'},
  ];
  activeIndices: number[] = [];

  @ViewChild('intro') intro!: ElementRef;
  show: boolean = false;

  @HostListener('document:scroll')
  onViewportScroll() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    const windowHeight = window.innerHeight;
    const boundingRectFive = this.intro.nativeElement.getBoundingClientRect();

    if (boundingRectFive.top <= windowHeight - 200) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  toggleActive(index: number) {
    if (this.activeIndices.includes(index)) {
      this.activeIndices = this.activeIndices.filter(i => i !== index);
    } else {
      this.activeIndices.push(index);
    }
  }

  getImageUrl(image: any): string {
    let url = image.originUrl;
    if (this.supportsWebp) {
      url = url.replace(/\.(jpg|jpeg|png)$/i, '.webp');
    }
    return url.replace(/([^:]\/)\/+/g, '$1');
  }


}
